var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2344 30.1348C33.9937 28.8848 30.9891 27.0606 29.5312 26.3255C27.6328 25.3692 27.4766 25.2911 25.9844 26.3997C24.9891 27.1395 24.3273 27.8005 23.1625 27.552C21.9977 27.3036 19.4664 25.9028 17.25 23.6934C15.0336 21.484 13.5516 18.8794 13.3023 17.7184C13.0531 16.5575 13.725 15.9036 14.4578 14.9059C15.4906 13.4997 15.4125 13.2653 14.5297 11.3669C13.8414 9.8903 11.9641 6.91373 10.7094 5.67936C9.36719 4.35358 9.36719 4.58795 8.50234 4.94733C7.79826 5.24357 7.12278 5.60367 6.48438 6.02311C5.23438 6.85358 4.54063 7.54342 4.05547 8.58014C3.57031 9.61686 3.35234 12.0473 5.85781 16.5989C8.36328 21.1505 10.1211 23.4778 13.7594 27.1059C17.3977 30.734 20.1953 32.6848 24.2852 34.9786C29.3445 37.8122 31.2852 37.2598 32.325 36.7755C33.3648 36.2911 34.0578 35.6036 34.8898 34.3536C35.3104 33.7162 35.6713 33.0415 35.968 32.338C36.3281 31.4762 36.5625 31.4762 35.2344 30.1348Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutline);
export default __webpack_public_path__ + "static/media/call-outline.d83acd7aee9af3d22f2ff390302a967f.svg";
export { ForwardRef as ReactComponent };